export function updateProperty(obj: any, path: string, value: any): any {
  var properties = path.split('.');
  var index = 0;
  var recurse = (parent, property) => {
    if (index == properties.length - 1) {
      return (parent[property] = value);
    }
    if (parent[property] == null) parent[property] = {};
    return typeof parent == 'function' ? null : recurse(parent[properties[index]], properties[++index]);
  };
  return recurse(obj, properties[index]);
}
